module.exports = __webpack_public_path__ + "img/bin.63fa5f20.svg";